export default __webpack_public_path__ + "static/media/sms_white.8e6905a4.svg";